import React from "react";
import { LayoutHOC } from "../../../base/ui/layout/layout";
import { checkStateMarketing } from "./checkStateMarketing";

export const createCheckStateMarketingPage = (layoutHOC: LayoutHOC) => {
  return layoutHOC(checkStateMarketing());
};
